import React, { useState, useCallback } from "react";
import { useHistory } from "react-router";
import PageHeader from "Components/Pages/Header";
import Breadcrumb from "Components/Shared/Breadcrumb";
import { Button } from "Components/Button";
import Input from "Components/Form/Input";
import {
  ListProductsRules,
  ProductRuleList,
  listProductsRules,
} from "Requests/ProductsRules";
import { LoadingText } from "Components/LoadingText";
import { Pagination } from "Components/Pagination";
import { useQuery } from "react-query";
import {
  SearchSection,
  SearchTitle,
  SearchWrapper,
  ListWrapper,
  EmptyState,
} from "./styles";

import * as S from "../../Partners/styles";
import { ListItem } from "../ListItem";
import { ModalRuleDetails } from "../ModalRuleDetails";

export const ProductRulesList = () => {
  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState("");
  const [depTerm, setDepTerm] = useState("");
  const [selectedRuleSet, setSelectedRuleSet] =
    useState<ProductRuleList | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [pageSelected, setPageSelected] = useState(1);
  const [disabledSearch, setDisabledSearch] = useState(false);

  const { data, isLoading } = useQuery<ListProductsRules>({
    queryKey: ["products-rules", depTerm, pageSelected],
    queryFn: () => listProductsRules(searchTerm, pageSelected),
    enabled: disabledSearch,
  });

  const runSearch = useCallback(async () => {
    setDisabledSearch(true);
    setDepTerm(searchTerm);
  }, [searchTerm, disabledSearch]);

  const onKeyPress = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === "Enter") {
      runSearch();
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target?.value ?? "";
    setSearchTerm(value);
  };

  const handleItemClick = (item: ProductRuleList) => {
    setSelectedRuleSet(item);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedRuleSet(null);
  };

  function handlePagination(e: any) {
    if (pageSelected === e.currentPage) return;

    setPageSelected(e.currentPage);
  }

  return (
    <S.Container className="entry-app-content">
      <div className="content-holder">
        <div>
          <div className="wrapper-header-content">
            <PageHeader title="Visualizar regras">
              <Breadcrumb
                list={[
                  {
                    path: "/regras/regras-produto",
                    label: "Regras Produto",
                    current: false,
                  },
                  {
                    path: "/regras/regras-produtos/lista",
                    label: "Visualizar regras",
                    current: true,
                  },
                ]}
              />
            </PageHeader>
            <div className="buttons-container">
              <Button
                outlined
                borderRadius="111"
                onClick={() => history.push("/regras/regras-produto")}
              >
                Criar nova regra
              </Button>
            </div>
          </div>
        </div>

        <main>
          <div className="form">
            <SearchSection>
              <SearchTitle>Buscar por sinônimo ou nome do produto</SearchTitle>
              <SearchWrapper>
                <Input
                  id="search-rules"
                  label=""
                  value={searchTerm}
                  onChange={handleSearchChange}
                  placeholder="Digite para buscar..."
                  type="text"
                  error=""
                  required={false}
                  purple={false}
                  multiline={false}
                  onBlur={undefined}
                  onFocus={undefined}
                  mask=""
                  maskChar=""
                  maxLength={200}
                  min={undefined}
                  description=""
                  small={false}
                  readOnly={false}
                  onKeyPress={onKeyPress}
                />
                <Button onClick={runSearch}>Buscar</Button>
              </SearchWrapper>
            </SearchSection>

            {!isLoading && data?.data?.length === 0 && (
              <EmptyState style={{ textAlign: "center" }}>
                Nenhum resultado encontrado.
              </EmptyState>
            )}

            {isLoading && <LoadingText text="Procurando produtos" />}

            {!isLoading && data && data?.data?.length > 0 && (
              <ListWrapper>
                {data?.data.map((item) => (
                  <ListItem
                    key={item.product_id}
                    item={item}
                    handleItemClick={handleItemClick}
                  />
                ))}
              </ListWrapper>
            )}

            {data?.total && data?.last_page > 1 && (
              <Pagination
                totalRecords={data?.total}
                currentPageSelected={pageSelected}
                pageLimit={1}
                pageNeighbours={1}
                onPageChanged={(e) => handlePagination(e)}
              />
            )}
          </div>
        </main>
      </div>

      <ModalRuleDetails
        isOpen={modalOpen}
        onClose={handleCloseModal}
        ruleSet={selectedRuleSet}
      />
    </S.Container>
  );
};

export default ProductRulesList;
